/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { LayoutWithStepper } from 'layouts';
import { injectIntl } from 'react-intl';
import moment from 'moment';
// import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import {
  stepAction, agreementAction, applicantAction, submitClicked, submitInit, authAction,
} from 'shared/store/actions';
// import { toast } from 'react-toastify';
import SignatureCanvas from 'react-signature-canvas';

// import OAuthImplicit from 'OAuthImplicit';
// import DocuSign from 'DocuSign';

import {
  PATH, FORM_KEYS, APPLICANT_HISTORY_CODE, CLIENT_CLASSIFICATION,
  // SIGNING_STATUS,
} from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';

import { isMobileOnly } from 'react-device-detect';

import validation from 'shared/validations';
// import ReactLoading from 'react-loading';
import {
  FooterAction, Options, FormElementContainer, Label, Button, PageContentWrapper,
} from 'components';
import selectors from 'shared/store/selectors';
// import apiRequest from 'shared/services/api';
// import docuconfig from 'DocuConfig';
import { SubPageMenu } from './components';

class FormAgreements extends Component {
  state = {
    trimmedDataURL: this.props.signature || null,
    isCanvasEmpty: true,
    isSubmit: false,
  }

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     // trimmedDataURL: this.props.signature || null,
  //     // isCanvasEmpty: true,
  //     isSubmit: false,

  //     isLoggingInToDocuSign: false,
  //     isSendingDocForSigning: false,
  //     isWaitingForSignature: false,
  //     isNativePopupAvailable: true,

  //     accessToken: this.props.dsUserDetail?.accessToken || undefined,
  //     expires: this.props.dsUserDetail?.expires || undefined,
  //     name: this.props.dsUserDetail?.name || undefined,
  //     email: this.props.dsUserDetail?.email || undefined,
  //     clientUserId: this.props.dsUserDetail?.clientUserId || undefined,
  //     externalAccountId: undefined,
  //     accountName: undefined,
  //     accountId: this.props.dsUserDetail?.accountId || undefined,
  //     baseUri: this.props.dsUserDetail?.baseUri || undefined,
  //     page: this.props.dsUserDetail?.accessToken ? 'loggedIn' : 'welcome', // initial page. Pages: welcome|loggedIn
  //     working: false,
  //     workingMessage: '',
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //     resultsEnvelopeJson: undefined,
  //     // formName: '',
  //     // formEmail: '',
  //     docPdf: undefined,
  //     docName: 'crm',
  //     docPdf2: undefined,
  //     docName2: 'crs',
  //     docPdf3: undefined,
  //     docName3: 'fatca',
  //   };
  //   this.oAuthImplicit = new OAuthImplicit(this);
  //   this.docusign = new DocuSign(this);

  //   // bind <this> for methods called by React via buttons, etc
  //   // this.logout = this.logout.bind(this);
  //   this.startAuthentication = this.startAuthentication.bind(this);
  //   // this.formNameChange = this.formNameChange.bind(this);
  //   // this.formEmailChange = this.formEmailChange.bind(this);
  //   this.sendEnvelope = this.sendEnvelope.bind(this);
  //   this.getEnvelope = this.getEnvelope.bind(this);
  //   this.receiveMessage = this.receiveMessage.bind(this);
  // }

  signatureCanvas = {}

  // async componentDidMount() {
  //   const config = docuconfig; // window.config;

  //   const {
  //     onUpdateCurrentStep,
  //     // intl, onUpdateSteps,
  //     isAllStepsCompleted, history,
  //     isAgreementReadyForQualified,
  //     clientClassification,
  //     signature, onGetAgreementStatus,
  //     // onUpdateTimestamp,
  //   } = this.props;

  //   onGetAgreementStatus();

  //   // const timestamp = moment().unix();
  //   // const timestampUTC = moment().utcOffset();
  //   // // update NDPF docs
  //   // onUpdateTimestamp(timestamp, timestampUTC);

  //   // if the url has a query parameter of ?error=logout_request (from a logout operation)
  //   // then remove it
  //   if (window.location.search && window.location.search === '?error=logout_request') {
  //     window.history.replaceState(null, '', config.DS_APP_URL);
  //   }

  //   if (config?.DS_REDIRECT_AUTHENTICATION) {
  //     const { hash } = window.location;
  //     if (!hash) { return; }
  //     // possible OAuth response
  //     this.setState({ working: true, workingMessage: 'Logging in' });
  //     await this.oAuthImplicit.receiveHash(hash);
  //     this.setState({ working: false });
  //   } else {
  //     // await authentication via the new tab
  //     window.addEventListener('message', this.receiveMessage, false);
  //   }

  //   if (signature && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) history.push(PATH.QUALIFIED_CONFIRMATION);
  //   /** Redirect to Homepage if all steps are completed else update steps */
  //   if (isAllStepsCompleted) {
  //     history.push(PATH.HOME);
  //   } else {
  //     onUpdateCurrentStep('step5');
  //     // onUpdateSteps(intl);
  //   }
  // }

  /**
     * Receive message from a child .
     * This method is only used if authentication is done
     * in a new tab. See file public/oauthResponse.html
     * @param {object} e
     */
  // async receiveMessage(e) {
  //   const { onUpdateSignature, onSaveApplicant } = this.props;
  //   const rawSource = e && e.data && e.data.source;
  //   const ignore = {
  //     'react-devtools-inject-backend': true,
  //     'react-devtools-content-script': true,
  //     'react-devtools-detector': true,
  //     'react-devtools-bridge': true,
  //   };
  //   const source = (rawSource && !ignore[rawSource]) ? rawSource : false;
  //   if (!source) { return; } // Ignore if no source field
  //   // console.log('SOURCE PostMessage ::', source, e.data);
  //   if (source === 'dsResponse') {
  //     const { accessToken, responseEnvelopeId } = this.state;
  //     this.docusign.signingCeremonyEnded(e.data);
  //     // console.log('???? ', e.data, { signingDetail });
  //     /** @note save signature info in the store */
  //     const params = {
  //       accessToken,
  //       envelopeId: responseEnvelopeId,
  //       status: SIGNING_STATUS.COMPLETE,
  //     };

  //     /** @note check status of the signing docs if signed or not */
  //     const { resultsEnvelopeJson } = await this.docusign.getEnvelope();
  //     // console.log(resultsEnvelopeJson, '<<<<<<<<<<<<<<<< ENVELOPE DETAILS');
  //     if (resultsEnvelopeJson.status === 'completed') {
  //       onUpdateSignature(FORM_KEYS.AGREEMENT.AOF_KYC_PROFILE_SIGNATURE, JSON.stringify(params));

  //       // this.setState({ isWaitingForSignature: false });
  //       onSaveApplicant(); // save signature on our backend
  //     }
  //     if (resultsEnvelopeJson.status === 'delivered') {
  //       toast.error('An error has occurred. Please sign the agreement again by clicking the button below. If the button is unresponsive, please refresh the page and try again.');
  //     }
  //     this.setState({ isSendingDocForSigning: false, isWaitingForSignature: false, isNativePopupAvailable: false });
  //     return;
  //   }
  //   if (source === 'oauthResponse') {
  //     this.setState({ working: true, workingMessage: 'Logging in' });
  //     const hash = e.data && e.data.hash;
  //     await this.oAuthImplicit.receiveHash(hash);
  //     this.setState({ working: false });
  //   }
  // }

  // startAuthentication() {
  //   this.setState({ isLoggingInToDocuSign: true });
  //   this.oAuthImplicit.startLogin();
  // }

  /**
     * Is the accessToken ok to use?
     * @returns boolean accessTokenIsGood
     */
  // checkToken() {
  //   if (
  //     !this.state.accessToken
  //           || this.state.expires === undefined
  //           || new Date() > this.state.expires
  //   ) {
  //     // Need new login. Only clear auth, don't clear the state (leave form contents);
  //     this.clearAuth();
  //     this.setState({ page: 'welcome', working: false });
  //     toast.error('Your login session with DocuSign has ended.\nPlease login again', {
  //       autoClose: 8000,
  //     });
  //     return false;
  //   }
  //   return true;
  // }

  /**
     * This method clears this app's authentication information.
     * But there may still be an active login session cookie
     * from the IdP. Your IdP may have an API method for clearing
     * the login session.
     */
  // logout() {
  //   this.clearAuth();
  //   this.clearState();
  //   this.setState({ page: 'welcome' });
  //   toast.success('You have logged out.', { autoClose: 5000 });
  //   this.oAuthImplicit.logout();
  // }

  /**
     * Clear authentication-related state
     */
  // clearAuth() {
  //   this.setState({
  //     accessToken: undefined,
  //     expires: undefined,
  //     accountId: undefined,
  //     externalAccountId: undefined,
  //     accountName: undefined,
  //     baseUri: undefined,
  //     name: undefined,
  //     email: undefined,
  //     clientUserId: undefined,
  //   });
  // }

  /**
     * Clear the app's form and related state
     */
  // clearState() {
  //   this.setState({
  //     // formName: '',
  //     // formEmail: '',
  //     clientUserId: undefined,
  //     working: false,
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //     resultsEnvelopeJson: undefined,
  //   });
  // }

  /**
     * Process the oauth results.
     * This method is called by the OAuthImplicit class
     * @param results
     */
  // async oAuthResults(results) {
  //   // get CRM document from api
  //   const { phoneNumber, token, onSaveDsUserInfo } = this.props;
  //   const endpoint = 'markaz/applicant/pdf';
  //   const endpointCrs = 'markaz/applicant/pdf/crs';
  //   const endpointFatca = 'markaz/applicant/pdf/fatca';

  //   const doc = await apiRequest.getPdfDocForDocuSign(endpoint, token, phoneNumber);
  //   const doc2 = await apiRequest.getPdfDocForDocuSign(endpointCrs, token, phoneNumber);
  //   const doc3 = await apiRequest.getPdfDocForDocuSign(endpointFatca, token, phoneNumber);

  //   if (doc && doc2 && doc3) {
  //     this.setState({
  //       accessToken: results.accessToken,
  //       expires: results.expires,
  //       name: results.name,
  //       clientUserId: results.clientUserId,
  //       externalAccountId: results.externalAccountId,
  //       email: results.email,
  //       accountId: results.accountId,
  //       accountName: results.accountName,
  //       baseUri: results.baseUri,
  //       page: 'loggedIn',
  //       // formName: results.name, // default: set to logged in user
  //       // formEmail: results.email,
  //       docPdf: doc,
  //       docPdf2: doc2,
  //       docPdf3: doc3,
  //     });

  //     // save user info of logged docuSign user in the store
  //     onSaveDsUserInfo(JSON.stringify({
  //       accessToken: results.accessToken,
  //       expires: results.expires,
  //       name: results.name,
  //       email: results.email,
  //       clientUserId: results.clientUserId,
  //       baseUri: results.baseUri,
  //       accountId: results.accountId,
  //     }));

  //     // toast.success(`Welcome ${results.name}, you are now logged in`); // @Todo we can maybe remmove toaster
  //     this.setState({ isLoggingInToDocuSign: false });
  //     // this.sendEnvelope();
  //   }
  // }

  // async sendEnvelope() {
  //   this.setState({
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //     resultsEnvelopeJson: undefined,
  //   });
  //   if (!this.checkToken()) {
  //     return; // Problem! The user needs to login
  //   }
  //   if (this.state.docPdf === undefined && this.state.docPdf2 === undefined && this.state.docPdf3 === undefined) {
  //     const { phoneNumber, token } = this.props;
  //     const endpoint = 'markaz/applicant/pdf';
  //     const endpointCrs = 'markaz/applicant/pdf/crs';
  //     const endpointFatca = 'markaz/applicant/pdf/fatca';
  //     const doc = await apiRequest.getPdfDocForDocuSign(endpoint, token, phoneNumber);
  //     const doc2 = await apiRequest.getPdfDocForDocuSign(endpointCrs, token, phoneNumber);
  //     const doc3 = await apiRequest.getPdfDocForDocuSign(endpointFatca, token, phoneNumber);
  //     this.setState({ docPdf: doc, docPdf2: doc2, docPdf3: doc3 });
  //   }
  //   // if (!this.state.formEmail || this.state.formEmail.length < 5) {
  //   //   toast.error("Problem: Enter the signer's email address");
  //   //   return;
  //   // }
  //   // if (!this.state.formName || this.state.formName.length < 5) {
  //   //   toast.error("Problem: Enter the signer's name");
  //   //   return;
  //   // }

  //   // if (!this.state.clientUserId || this.state.clientUserId.length < 5) {
  //   //   toast.error("Problem: Enter the signer's client UserId");
  //   //   return;
  //   // }

  //   this.setState({ working: true, workingMessage: 'Sending envelope', isSendingDocForSigning: true });
  //   const isMultiDocs = true;
  //   const results = await this.docusign.sendEnvelope(isMultiDocs);
  //   const { apiRequestsReset } = results;
  //   const responseApiRequestsReset = apiRequestsReset
  //     ? new Date(apiRequestsReset) : undefined;

  //   // console.log('embeddedSigningCeremony here', this.state.accountId, this.state.name, this.state.email, results.envelopeId);
  //   this.setState({
  //     working: false,
  //     responseSuccess: results.success,
  //     responseErrorMsg: results.errorMsg,
  //     responseEnvelopeId: results.envelopeId,
  //     responseAvailableApiRequests: results.availableApiRequests,
  //     responseTraceId: results.traceId,
  //     responseApiRequestsReset,
  //   });

  //   const signer = {
  //     clientUserId: this.state.clientUserId,
  //     name: this.state.name,
  //     email: this.state.email,
  //   };
  //   const objParam = {
  //     envelopeId: results.envelopeId,
  //     signer,
  //     is1stAgreement: true,
  //   };
  //   // const isESCProcessing =
  //   await this.docusign.embeddedSigningCeremony(objParam);
  //   // console.log({ isESCProcessing });
  //   this.setState({ isSendingDocForSigning: false, isWaitingForSignature: true, isNativePopupAvailable: true });

  //   // if (isESCProcessing) {
  //   //   this.setState({ isSendingDocForSigning: false, isWaitingForSignature: true, isNativePopupAvailable: true });
  //   // } else {
  //   //   this.setState({ isSendingDocForSigning: false, isWaitingForSignature: false, isNativePopupAvailable: false });
  //   // }
  // }

  // async getEnvelope() {
  //   this.setState({
  //     responseErrorMsg: undefined,
  //     responseEnvelopeId: undefined,
  //     responseAvailableApiRequests: undefined,
  //     responseApiRequestsReset: undefined,
  //     responseSuccess: undefined,
  //     responseTraceId: undefined,
  //   });
  //   if (!this.checkToken()) {
  //     return; // Problem! The user needs to login
  //   }
  //   if (!this.state.responseEnvelopeId) {
  //     toast.error('Problem: First send an envelope');
  //     return;
  //   }

  //   this.setState({ working: true, workingMessage: "Fetching the envelope's status" });
  //   const results = await this.docusign.getEnvelope();
  //   const { apiRequestsReset } = results;
  //   const responseApiRequestsReset = apiRequestsReset
  //     ? new Date(apiRequestsReset) : undefined;
  //   this.setState({
  //     working: false,
  //     responseSuccess: results.success,
  //     responseErrorMsg: results.errorMsg,
  //     responseAvailableApiRequests: results.availableApiRequests,
  //     responseTraceId: results.traceId,
  //     resultsEnvelopeJson: results.resultsEnvelopeJson,
  //     responseApiRequestsReset,
  //   });
  // }

  componentDidMount() {
    const {
      onUpdateCurrentStep,
      // intl, onUpdateSteps,
      isAllStepsCompleted, history,
      isAgreementReadyForQualified,
      clientClassification,
      signature, onGetAgreementStatus,
    } = this.props;

    onGetAgreementStatus();
    if (signature && clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) history.push(PATH.QUALIFIED_CONFIRMATION);
    /** Redirect to Homepage if all steps are completed else update steps */
    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      onUpdateCurrentStep('step5');
      // onUpdateSteps(intl);
    }
  }


  redoSignature = () => {
    this.setState({ trimmedDataURL: null });
  }

  // /** Clear Signature canvass */
  clearSignature = () => {
    this.signatureCanvas.clear();
    this.setState({ isCanvasEmpty: true });
  }

  // /** save signature */
  trimSignature = () => {
    this.setState({
      trimmedDataURL: this.signatureCanvas.getTrimmedCanvas()
        .toDataURL('image/png'),
    });
  }

  onHandleUpdateAotKyc = ({ target }) => {
    const { id } = target;
    this.props.onUpdateAotKyc(id);
  }

  onHandleUpdateProfile = ({ target }) => {
    const { id } = target;
    this.props.onUpdateProfile(id);
  }

  onSubmit = () => {
    // const {
    //   // onUpdateSignature,
    //   onSaveApplicant, history,
    //   // onUpdateTimestamp,
    //   selectedAotKyc, selectedProfile, signature, intl, onSubmitClick, onSubmitInit, onUpdateHistory,
    //   clientClassification,
    //   isAgreementReadyForQualified,
    //   onSendApplicationToEmailAfterSign, isFirstAgreementCompleted,
    // } = this.props;

    const {
      onUpdateSignature, onSaveApplicant, history, onUpdateTimestamp,
      selectedAotKyc, selectedProfile, signature, intl, onSubmitClick, onSubmitInit, onUpdateHistory,
      clientClassification, isAgreementReadyForQualified, onSendApplicationToEmailAfterSign, isFirstAgreementCompleted,
    } = this.props;

    const isPageValid = validation.formAgreementSchema(intl).isValidSync({ aofKyc: selectedAotKyc, profile: selectedProfile, aofKycProfileSignature: signature });
    onSubmitClick();
    this.setState({ isSubmit: true });

    // ADDED: history step 5
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_CRM.code, APPLICANT_HISTORY_CODE.SIGN_CRM.codeI18n);
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_CRS.code, APPLICANT_HISTORY_CODE.SIGN_CRS.codeI18n);
    onUpdateHistory(APPLICANT_HISTORY_CODE.SIGN_FATCA.code, APPLICANT_HISTORY_CODE.SIGN_FATCA.codeI18n);
    // console.log('isPageValid', isPageValid);

    // if (isPageValid) {
    //   // const timestamp = moment().unix();
    //   // const timestampUTC = moment().utcOffset();
    //   // onUpdateTimestamp(timestamp, timestampUTC);

    //   const generatePDF = true;
    //   const signed = true;
    //   onSaveApplicant(generatePDF, signed);
    //   onSubmitInit();

    //   /** Submit email notification to client on first signing of agreement */
    //   // if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED || clientClassification === CLIENT_CLASSIFICATION.RETAIL) {
    //   //   onSendApplicationToEmailAfterSign();
    //   // }

    //   if ((clientClassification === CLIENT_CLASSIFICATION.QUALIFIED) && !isAgreementReadyForQualified) {
    //     if (isFirstAgreementCompleted) {
    //       history.push(PATH.QUALIFIED_CONFIRMATION);
    //     } else {
    //       history.push({
    //         pathname: PATH.QUALIFIED_CONFIRMATION,
    //         state: { isFirstVisit: true },
    //       });
    //     }
    //   }

    //   if (clientClassification === CLIENT_CLASSIFICATION.RETAIL) history.push(PATH.AGREEMENT);
    //   // if ((clientClassification === CLIENT_CLASSIFICATION.RETAIL && isAgreementReadyForQualified) || (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && isAgreementReadyForQualified)) history.push(PATH.AGREEMENT);
    // }

    if ((this.state.trimmedDataURL === null || this.state.trimmedDataURL === '') && !(this.signatureCanvas && this.signatureCanvas.isEmpty())) {
      this.setState({
        trimmedDataURL: this.signatureCanvas.getTrimmedCanvas()
          .toDataURL('image/png'),
      }, () => {
        const { trimmedDataURL } = this.state;
        const timestamp = moment().unix();
        const timestampUTC = moment().utcOffset();
        onUpdateSignature(FORM_KEYS.AGREEMENT.AOF_KYC_PROFILE_SIGNATURE, trimmedDataURL);
        onUpdateTimestamp(timestamp, timestampUTC);
        onSaveApplicant(true);
        onSubmitInit();

        if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED || clientClassification === CLIENT_CLASSIFICATION.RETAIL) {
          /** Submit email notification to client on first signing of agreement */
          onSendApplicationToEmailAfterSign();
        }

        if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) {
          if (isFirstAgreementCompleted) {
            history.push(PATH.QUALIFIED_CONFIRMATION);
          } else {
            history.push({
              pathname: PATH.QUALIFIED_CONFIRMATION,
              state: { isFirstVisit: true },
            });
          }
        }
        if (clientClassification === CLIENT_CLASSIFICATION.RETAIL || (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && isAgreementReadyForQualified)) history.push(PATH.AGREEMENT);
      });
    } else {
      onSaveApplicant(true);
      if (isPageValid) {
        if (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && !isAgreementReadyForQualified) {
          if (isFirstAgreementCompleted) {
            history.push(PATH.QUALIFIED_CONFIRMATION);
          } else {
            history.push({
              pathname: PATH.QUALIFIED_CONFIRMATION,
              state: { isFirstVisit: true },
            });
          }
        }
        if (clientClassification === CLIENT_CLASSIFICATION.RETAIL || (clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && isAgreementReadyForQualified)) history.push(PATH.AGREEMENT);
      }
    }
  }

  render() {
    const { trimmedDataURL, isCanvasEmpty } = this.state;
    const {
      history, intl, selectedAotKyc, selectedProfile,
      signature, isSubmitClicked,
    } = this.props;
    const { agreementAofKycOptions, agreementProfileOptions } = arrOptions;

    const isPageValid = validation.formAgreementSchema(intl).isValidSync({ aofKyc: selectedAotKyc, profile: selectedProfile, aofKycProfileSignature: signature });

    const footer = (
      <FooterAction
        isSingleButton={false}
        leftButton={intl.formatMessage({ id: 'backToPreview' })}
        onLeftButtonClick={() => history.push(`${PATH.PREVIEW}/crm`)}
        rightButton={intl.formatMessage({ id: 'submit' })}
        onRightButtonClick={this.onSubmit}
        // isDisabled={!(selectedAotKyc.length === 3 && selectedProfile.length === 2) || isEmpty(signature) || isSubmitClicked}
        isDisabled={!(selectedAotKyc.length === 3 && selectedProfile.length === 2) || (isCanvasEmpty && !trimmedDataURL) || isSubmitClicked}
      />
    );

    // console.log(this.state.isSendingDocForSigning, this.state.isWaitingForSignature);

    return (
      <>
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container">
            <SubPageMenu title="agreements.for" hideMenu />

            <section className="content-container__main content-container__main--withPadding">
              <FormElementContainer>
                <Label label={intl.formatMessage({ id: 'agreements.aofKyc' })} />
                <Options
                  type="checkbox"
                  name="agreements"
                  optionList={agreementAofKycOptions}
                  defaultValue={selectedAotKyc}
                  onCheckMarkChange={this.onHandleUpdateAotKyc}
                />
              </FormElementContainer>

              <hr />

              <FormElementContainer>
                <Label label={intl.formatMessage({ id: 'agreements.profile' })} />
                <Options
                  type="checkbox"
                  name="agreements"
                  optionList={agreementProfileOptions}
                  defaultValue={selectedProfile}
                  onCheckMarkChange={this.onHandleUpdateProfile}
                />
              </FormElementContainer>

              <hr />

              <FormElementContainer customClass="withButton">
                <Label label={intl.formatMessage({ id: 'agreements.digitalSignature' })} />
                <p style={{ marginTop: 'unset' }}><small><em>{intl.formatMessage({ id: 'digital.signature.info' })}</em></small></p>

                {/* {this.state.page === 'welcome' && selectedAotKyc.length === 3 && selectedProfile.length === 2 && !signature ? (
                  <div>
                    {this.state.isLoggingInToDocuSign ? (
                      <div className="docuSign-status">
                        <div>
                          <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                          <span>{intl.formatMessage({ id: 'docuSign.loggingIn' })}</span>
                        </div>
                      </div>
                    ) : <Button isTertiary isFullWidth value={intl.formatMessage({ id: 'docuSign.login' })} onButtonClick={this.startAuthentication} />}
                  </div>
                ) : (
                  <>
                    {(!this.state.isSendingDocForSigning || !this.state.isWaitingForSignature) && !isPageValid && selectedAotKyc.length === 3 && selectedProfile.length === 2 ? (
                      <div style={{ display: 'block', marginBottom: '10px' }}>
                        <Button isTertiary isFullWidth value={intl.formatMessage({ id: 'docuSign.signAgreement' })} onButtonClick={this.sendEnvelope} isDisabled={this.state.isSendingDocForSigning || this.state.isWaitingForSignature} />
                      </div>
                    ) : null}
                    <div className="docuSign-status">
                      {this.state.isSendingDocForSigning ? (
                        <div>
                          <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                          <span>{intl.formatMessage({ id: 'docuSign.processing' })}</span>
                        </div>
                      ) : null}
                      {this.state.isSendingDocForSigning && this.state.isWaitingForSignature ? (
                        <div>
                          <ReactLoading height="24px" width="24px" color="#47B7F5" type="spin" />
                          <span>{intl.formatMessage({ id: 'docuSign.waiting' })}</span>
                        </div>
                      ) : null}
                    </div>
                  </>
                )} */}

                {/* {this.state.page === 'loggedIn' && selectedAotKyc.length === 3 && selectedProfile.length === 2 && this.state.accessToken && isEmpty(signature) ? (
                  <Button isTertiary isFullWidth value="Sign agreement" onButtonClick={this.sendEnvelope} />
                ) : null} */}

                {/* {isPageValid ? (
                  <div className="docuSign-status">
                    <span className="docuSign-status__completed">{intl.formatMessage({ id: 'docuSign.complete' })}</span>
                  </div>
                ) : null} */}

                {/* <DigitalSignature /> */}
                {!trimmedDataURL && (
                <>
                  <SignatureCanvas
                    onEnd={() => this.setState({ isCanvasEmpty: this.signatureCanvas.isEmpty() })}
                    penColor="black"
                    canvasProps={{ width: isMobileOnly ? 400 : 861, height: 200, className: 'sigCanvas' }}
                    backgroundColor={isMobileOnly ? 'white' : '#f4f4f4'}
                    ref={(ref) => { this.signatureCanvas = ref; }}
                  />
                  <Button isTertiary isOutlineButton isSmall onButtonClick={this.clearSignature} value={intl.formatMessage({ id: 'clear' })} />
                </>
                )}

                {trimmedDataURL
                  ? (
                    <>
                      <img
                        src={trimmedDataURL}
                        alt="signature"
                      />
                      <Button isTertiary isOutlineButton isSmall onButtonClick={this.redoSignature} value={intl.formatMessage({ id: 'redo' })} />
                    </>
                  )
                  : null}

                {!isPageValid && isSubmitClicked && <span className="notification notification--error">{intl.formatMessage({ id: 'validation.signature' })}</span>}
              </FormElementContainer>
            </section>
          </div>
          {!isMobileOnly && footer}
        </PageContentWrapper>
        {isMobileOnly && footer}
      </>
    );
  }
}

const mapStateToProps = state => ({
  selectedAotKyc: state.agreementReducer.aofKyc.selected,
  selectedProfile: state.agreementReducer.profile.selected,
  signature: selectors.getAofKycProfileSignature(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
  clientClassification: selectors.getClientClassification(state),
  isFirstAgreementCompleted: selectors.isFirstAgreementCompleted(state),
  isAgreementReadyForQualified: selectors.getIsAgreementReadyStatus(state),

  dsUserDetail: selectors.getDsUserDetail(state),
  phoneNumber: selectors.getPhoneNumber(state),
  token: selectors.getToken(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateAotKyc: selectedId => dispatch(agreementAction.updateAofKyc(selectedId)),
  onUpdateProfile: selectedId => dispatch(agreementAction.updateProfileAgreement(selectedId)),
  onUpdateCurrentStep: currentStep => dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: intl => dispatch(stepAction.updateSteps(intl)),
  onSaveApplicant: (isGenerate, isSigned) => dispatch(applicantAction.updateApplicant(isGenerate, isSigned)),
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),

  onGetAgreementStatus: () => dispatch(agreementAction.getQualifiedAgreementStatus()),

  onUpdateSignature: (name, value) => dispatch(agreementAction.updateSignature(name, value)),
  onUpdateTimestamp: (timestamp, timestampUTC) => dispatch(agreementAction.updateAofKycProfileTimestamp(timestamp, timestampUTC)),
  // onUpdateTimestamp: (timestamp, timestampUTC) => dispatch(agreementAction.updateNdpfProposedPlanTimestamp(timestamp, timestampUTC)),

  onSubmitClick: () => dispatch(submitClicked()),
  onSubmitInit: () => dispatch(submitInit()),
  onSendApplicationToEmailAfterSign: () => dispatch(applicantAction.sendApplicationToEmailAfterSign()),

  onSaveDsUserInfo: payload => dispatch(authAction.saveDsUserDetail(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(FormAgreements)));
